import { FieldArray, Form, Formik } from "formik";
import { remove } from "jszip";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { useRef, useState } from "react";
import Spinner from "../spinner/spinner";
import { Toast } from "primereact/toast";
import { InputMask } from "primereact/inputmask";

const initialValues = {
  name: "",
  phoneNumber: "",
  email: "",
  shipTo: "",
  shipDate: "",
  lineItems: [
    {
      item: "",
      itemDescription: "",
      quantity: ""
    }
  ]
};

const AddNewPhoneOrder = (props) => {
  const toast = useRef(null);
  const formRef = useRef(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableFields, setDisableFields] = useState(false);

  const navigateToPhoneOrderTable = (
    showPhoneOrderTable,
    showAddNewPhoneOrder
  ) => {
    props?.alterComponent(showPhoneOrderTable, showAddNewPhoneOrder);
  };

  const createOrder = async (formBody) => {
    setShowSpinner(true);

    setShowSpinner(false);

    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Order Created successfully.",
      life: 1000
    });

    setTimeout(() => {
      navigateToPhoneOrderTable(true, false);
    }, 1000);
  };

  const lineItemsHeader = () => {
    return (
      <div className="flex align-items-center justify-content-center">
        Line Items - {formRef?.current?.values?.lineItems?.length}
      </div>
    );
  };

  const deleteLineItemHandler = (index) => {
    if (formRef?.current?.values?.lineItems?.length === 1) {
      toast.current.show({
        severity: "warn",
        summary: "Warning",
        detail: "At least one line item is required.",
        life: 2000
      });
      return;
    }

    const lineItems = [...formRef?.current?.values?.lineItems];
    lineItems.splice(index, 1);
    formRef.current.setFieldValue("lineItems", lineItems);
  };

  return (
    <>
      <br></br>

      {showSpinner && <Spinner />}

      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          createOrder(values);
        }}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form onSubmit={handleSubmit} ref={formRef}>
            <Panel header="General Information" toggleable>
              <div className="formgrid grid">
                <div className="field col-4">
                  <label htmlFor="name">Name</label>
                  <InputText
                    id="name"
                    value={values?.name}
                    onChange={handleChange}
                    className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Enter Name"
                  />
                </div>
                <div className="field col-4">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <InputMask
                    mask="(999) 999-9999"
                    placeholder="(999) 999-9999"
                    id="phoneNumber"
                    value={values?.phoneNumber}
                    onChange={handleChange}
                    className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                  />
                </div>
                <div className="field col-4">
                  <label htmlFor="email">Email</label>
                  <InputText
                    id="email"
                    value={values?.email}
                    onChange={handleChange}
                    className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Enter Email"
                  />
                </div>
              </div>
            </Panel>

            <Panel header="Purchase Order Details" className="mt-4" toggleable>
              <div className="formgrid grid">
                <div className="field col-4">
                  <label htmlFor="shipTo">Ship To</label>
                  <InputText
                    id="shipTo"
                    value={values?.shipTo}
                    onChange={handleChange}
                    className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Enter Ship To"
                  />
                </div>
                <div className="field col-4">
                  <label htmlFor="shipDate">Ship Date</label>
                  <Calendar
                    id="shipDate"
                    value={values?.shipDate}
                    onChange={handleChange}
                    disabled={disableFields}
                    placeholder="Ship Date"
                  />
                </div>
              </div>
            </Panel>

            <Panel header={lineItemsHeader} className="mt-4" toggleable>
              <FieldArray name="lineItems">
                {({ remove, push }) => (
                  <div>
                    {values.lineItems.length > 0 &&
                      values.lineItems.map((lineItem, index) => (
                        <div className="formgrid grid" key={index}>
                          <div className="field col-3">
                            <label htmlFor={`lineItems.${index}.item`}>
                              Item {index + 1}
                            </label>
                            <InputText
                              id={`lineItems.${index}.item`}
                              value={values?.lineItems[index].item}
                              onChange={handleChange}
                              className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                              placeholder="Enter Item"
                            />
                          </div>
                          <div className="field col-4">
                            <label
                              htmlFor={`lineItems.${index}.itemDescription`}
                            >
                              Item Description
                            </label>
                            <InputText
                              id={`lineItems.${index}.itemDescription`}
                              value={values?.lineItems[index].itemDescription}
                              onChange={handleChange}
                              className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                              placeholder="Enter Item Description"
                            />
                          </div>
                          <div className="field col-3">
                            <label htmlFor={`lineItems.${index}.quantity`}>
                              Quantity
                            </label>
                            <InputText
                              id={`lineItems.${index}.quantity`}
                              value={values?.lineItems[index].quantity}
                              onChange={handleChange}
                              className="text-base text-color surface-overlay border-2 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                              placeholder="Enter Quantity"
                            />
                          </div>
                          <div className="field col-2 flex align-items-center justify-content-center pt-4">
                            <Button
                              icon="pi pi-trash"
                              rounded
                              text
                              type="button"
                              severity="danger"
                              aria-label="Cancel"
                              size="large"
                              onClick={() => deleteLineItemHandler(index)}
                            ></Button>
                          </div>
                        </div>
                      ))}

                    <div className="mt-2 flex align-items-center justify-content-center">
                      <Divider />
                      <Button
                        className="flex flex-shrink-0"
                        label="Add New Line Item"
                        type="button"
                        severity="secondary"
                        onClick={() =>
                          push({ item: "", itemDescription: "", quantity: "" })
                        }
                      ></Button>
                      <Divider />
                    </div>
                  </div>
                )}
              </FieldArray>
            </Panel>

            <div className="mt-6 flex align-items-center justify-content-end">
              <Button label="Create" type="submit" severity="success"></Button>
              <Button
                label="Cancel"
                className="ml-2"
                severity="danger"
                onClick={() => navigateToPhoneOrderTable(true, false)}
              ></Button>
            </div>

            <br></br>
          </Form>
        )}
      </Formik>

      <Toast ref={toast} position="center" />
    </>
  );
};

export default AddNewPhoneOrder;
